import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment ClassRequestFragment on ClassRequest {
    uid
    age
    content
  }
`;
